"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var ButtonsHolder_1 = __importDefault(require("components/Inputs/Buttons/ButtonsHolder"));
var LoadingTextBase = function () { return ((0, jsx_runtime_1.jsx)(ButtonsHolder_1.default, __assign({ className: "py-5" }, { children: (0, jsx_runtime_1.jsx)("img", { src: end2end_1.IS_RECHARGLY ? '/generic-loader.gif' : '/hudled-loader.gif', alt: "Our platform is loading", height: 42 }) }))); };
exports.default = LoadingTextBase;
